var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "res-button"
  }, [_vm.isBtnGroup ? [_c('el-button-group', _vm._l(_vm.btnsOptions, function (item, index) {
    return _c('el-button', _vm._b({
      key: item.id,
      attrs: {
        "type": item.type,
        "icon": item[_vm.iconKey],
        "disabled": item.disabled || !_vm.edit || _vm.disabled
      },
      on: {
        "click": _vm.handleClick
      }
    }, 'el-button', _vm.$attrs, false), [_vm._t("buttons", function () {
      return [_vm._v(" " + _vm._s(item[_vm.labelKey])), _c('i', {
        staticClass: "el-icon--right",
        class: item.rightIcon
      })];
    }, {
      "data": item,
      "index": `slot_${index}`
    })], 2);
  }), 1)] : [_c('el-button', _vm._b({
    attrs: {
      "native-type": _vm.nativeType,
      "disabled": !_vm.edit || _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'el-button', _vm.$attrs, false), [_vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.buttonName)), _c('i', {
      staticClass: "el-icon--right",
      class: _vm.$attrs.rightIcon
    })];
  })], 2)], _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };